




















import { EntityStatus } from '@/api';
import { Entity } from '@/models/entity';
import { PaginationPageProps } from '@/models/pagination-page-props';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class EntityPaginationRouter<T extends Entity> extends Vue {
	@Prop({ required: true, type: Function })
	public linkGenerator!: (
		props: PaginationPageProps,
	) => { name: string; params: { [key: string]: string } };

	@Prop({ required: true, type: Function })
	public paginationText!: (props: PaginationPageProps) => string;

	@Prop({ required: true, type: Function })
	public badgeText!: (props: PaginationPageProps) => string;

	@Prop({ required: true, type: Array })
	public entities!: T[];

	public badgeColor(props: PaginationPageProps): string {
		const entity: T = this.entities[props.page - 2];
		if (entity.status === EntityStatus.Live) {
			return 'success';
		}
		if (entity.status === EntityStatus.Cancelled || entity.status === EntityStatus.Removed) {
			return 'danger';
		}
		return 'warning';
	}

	public isRemovedOrCancelled(paginationProps: PaginationPageProps): boolean {
		return [EntityStatus.Removed, EntityStatus.Cancelled].includes(this.getStatus(paginationProps));
	}

	public getStatus(paginationProps: PaginationPageProps): EntityStatus {
		const entity: any = this.entities[paginationProps.index - 1];
		return entity?.status ?? EntityStatus.Live;
	}
}
